export const SectionHeading = ({ label, title, body, align = "left", as: H = "h2", className = "" }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""} ${className}`}>
    {label && <p className="label-mono text-[#FF5500]">{label}</p>}
    <H className="mt-4 font-display text-2xl font-bold uppercase leading-snug tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">{title}</H>
    {body && <p className="mt-5 text-base leading-relaxed text-slate-400 md:text-lg">{body}</p>}
  </div>
);

export const PageHero = ({ label, title, body }) => (
  <section className="relative overflow-hidden border-b border-white/5">
    <div className="grid-bg absolute inset-0 opacity-60" aria-hidden="true" />
    <div className="container-x relative py-20 sm:py-28">
      <p className="label-mono text-[#FF5500] reveal">{label}</p>
      <h1 className="mt-5 max-w-4xl font-display text-4xl font-extrabold uppercase leading-[1.05] tracking-tight text-slate-50 sm:text-5xl lg:text-6xl reveal" style={{ animationDelay: "80ms" }}>{title}</h1>
      {body && <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400 md:text-lg reveal" style={{ animationDelay: "160ms" }}>{body}</p>}
    </div>
  </section>
);
